<template>

        <v-card
            class="product-box"
            :class= "{'product-box-mobile' : ($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly) }"
        >
             <v-img
                :src= src+image.imageName
                width="380"
                height ="240"
                contain
            >
        </v-img>
        <v-divider color="#60050B"></v-divider>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-row justify="center">
                       <div class="menu-name">
                           {{image.menuName}} 
                       </div>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                    
                <v-btn text color="primary" :to="{name: 'updateMenu', params: {menu:  image}}">Update</v-btn>
                <v-col>
                    <v-row justify="end">
                        <div class="mb-2">Price: {{image.price}}</div>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>

        </v-card>
</template>

<script>
export default {
    props: ["image"],

    computed: {
        src: function() {
            if(process.env.NODE_ENV === 'production') {
                return "/api/images/image?filename="
            } else {
                return "http://localhost:5000/api/images/image?filename="
            }
        }
    },
}
</script>

<style>
.product-box{
    width: 360px;
    height: 360px;
    margin-top: 25px;
    margin-right: 20px;
    margin-left: 10px;
    border-radius: 6px;
    background-color: white;
    box-shadow: 0 1px 1px 0 rgba(0, 160, 35, 0.4), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    color: #34026a;
  }

  .product-box-mobile{
    width: 160px;
    height: 260px;
    margin-top: 15px;
    margin-right: 6px;
    margin-left: 6px;
    background-color: white;
    text-align: center;
    font-size: 16px;
    color: #34026a;
  }
  .product-title{
    text-align: center;
    font-size: 12px;
    font-style: italic;
    font-family: monospace;
    color: grey;
     
  }

  .product-title-mobile{
    
    font-size: 12px;
    color:black;
    
  }
  .menu-name {
      color: gray;
      font-size: 26px;
      font-style: normal;
      font-stretch: expanded;
      font-weight: 400;
  }
</style>